import { createContext, FC, ReactNode } from 'react'
import RussianPokerStore from '../RussianPokerStore'

const store = new RussianPokerStore()

const RussianPokerStoreContext = createContext<RussianPokerStore | null>(null)

interface StoreProviderProps {
  gameId: string
  children: ReactNode
}

export const RussianPokerStoreProvider: FC<StoreProviderProps> = ({ children, gameId }) => {
  store.setGameId(gameId)
  return <RussianPokerStoreContext.Provider value={store}>{children}</RussianPokerStoreContext.Provider>
}

export default RussianPokerStoreContext
